import React from "react";
import "./PcaWhy.css";
import WhyProblems from "./PcaWhyProblems";

function PcaWhy() {
  return (
    <section className="why-section" id="why">
      <div className="why__badge">The Problem</div>
      <h2 className="why__headline">Why most Porsche pricing is guesswork</h2>
      <WhyProblems />
    </section>
  );
}

export default PcaWhy;
